"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MiniTip_1 = require("mobile/components/MiniTip");
var link_1 = require("mobile/utils/link");
var flashsales_1 = require("services/flashsales/flashsales");
var s = require("./index.scss");
var Calendar = (function (_super) {
    __extends(Calendar, _super);
    function Calendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notAllow = function () {
            var closeModal = _this.props.closeModal;
            closeModal(false);
        };
        _this.changeRemind = function (settingId, gpid, remindStatus) {
            flashsales_1.UserSetProductsRemind({
                settingId: settingId,
                gpid: gpid,
                remindStatus: remindStatus
            }).then(function (_a) {
                var code = _a.code, message = _a.message;
                if (code === 0) {
                    var tip = remindStatus
                        ? "A reminder will be sent 3 minutes before start of sale"
                        : "Cancel the reminder and you may miss the event";
                    var _b = _this.props, calendarData = _b.calendarData, changeRemindMeState = _b.changeRemindMeState;
                    changeRemindMeState(calendarData.index, remindStatus);
                    MiniTip_1.default(tip);
                }
                else {
                    MiniTip_1.default(message);
                }
            });
        };
        _this.rightBtn = function () {
            var closeModal = _this.props.closeModal;
            closeModal(false);
            link_1.login();
        };
        return _this;
    }
    Calendar.prototype.render = function () {
        var isRemindMe = this.props.calendarData.isRemindMe;
        var text = "You need to open the “Notification”in Push Notifications.";
        var btnText = isRemindMe ? "Go Setting" : "Allow";
        return (React.createElement("div", { className: s.calendar },
            React.createElement("p", { className: s.text }, text),
            React.createElement("div", { className: s.btns },
                React.createElement("div", { onClick: this.notAllow }, "Not Allow"),
                React.createElement("div", { onClick: this.rightBtn }, btnText))));
    };
    return Calendar;
}(React.Component));
exports.default = Calendar;
